import React from 'react';
import styled from 'styled-components';

import { Modal, ModalPosition, Container } from 'ui/components/styled';

export const SuccessModal = ({ children, onClose, ...rest }) => {
  return (
    <Modal
      padding="1.5rem 2rem"
      onClose={onClose}
      position={ModalPosition.TOP_CENTER}
      top="25%"
      width="40%"
      maxWidth="600px"
      bg="#f2fff5"
      {...rest}
    >
      <Content>{children}</Content>
    </Modal>
  );
};

const Content = styled(Container)`
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  color: #00aa22;
`;
